import React, { useEffect } from "react";
import "./Contact.css";
import { 
  FaEnvelope, 
  FaPhone, 
  FaMapMarkerAlt, 
  FaFacebookF, 
  FaTwitter, 
  FaLinkedinIn, 
  FaInstagram,
  FaPaperPlane 
} from "react-icons/fa";
import Aos from "aos";
import "aos/dist/aos.css";

export default function Contact() {
  useEffect(() => {
    Aos.init({
      duration: 1000,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1.0)',
      once: false,
    });
  }, []);

  return (
    <div className="contact-container">
      {/* Contact Hero Section */}
      <section className="contact-hero">
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="hero-content" data-aos="fade-up">
            <h1>Get <span className="text-highlight">In Touch</span></h1>
            <p>We would love to hear from you! Reach out for inquiries, questions, or to discuss your next project.</p>
          </div>
        </div>
        
        {/* Animated SVGs */}
        <div className="contact-animated-shapes">
          <svg className="animated-blob blob-1" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <path fill="#ffffff" opacity="0.05" d="M44.3,-52.9C58.3,-46.5,71.3,-33.2,76.1,-16.7C81,-0.3,77.8,19.3,68.2,33.5C58.7,47.6,42.8,56.4,26.2,61.7C9.5,67,-7.9,68.9,-24.7,64.7C-41.5,60.6,-57.7,50.5,-65.4,36.1C-73.1,21.6,-72.3,2.8,-67.1,-13.5C-61.8,-29.8,-52.2,-43.5,-39.8,-50.4C-27.4,-57.3,-12.1,-57.3,2.6,-60.3C17.3,-63.4,30.3,-59.3,44.3,-52.9Z" transform="translate(100 100)">
              <animateTransform 
                attributeName="transform" 
                type="translate" 
                values="95 95; 105 95; 105 105; 95 105; 95 95" 
                dur="20s" 
                repeatCount="indefinite" />
            </path>
          </svg>
          
          <svg className="animated-blob blob-2" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <path fill="#ffffff" opacity="0.05" d="M53.2,-60.8C66.2,-53.3,72.5,-33.5,77.2,-12.4C81.9,8.7,85,31.2,75.3,43.4C65.7,55.7,43.3,57.7,23.7,62.1C4.1,66.4,-12.7,73,-28.9,69.5C-45.2,66,-60.8,52.4,-67.2,36.1C-73.6,19.7,-70.7,0.6,-67.2,-19.1C-63.7,-38.8,-59.6,-59.2,-47.1,-66.9C-34.7,-74.5,-13.9,-69.4,3.7,-73.8C21.2,-78.2,40.2,-68.3,53.2,-60.8Z" transform="translate(100 100)">
              <animateTransform 
                attributeName="transform" 
                type="translate" 
                values="105 105; 95 105; 95 95; 105 95; 105 105" 
                dur="25s" 
                repeatCount="indefinite" />
            </path>
          </svg>
          
          {/* Floating particles */}
          <div className="floating-particle p1"></div>
          <div className="floating-particle p2"></div>
          <div className="floating-particle p3"></div>
          <div className="floating-particle p4"></div>
          <div className="floating-particle p5"></div>
          <div className="floating-particle p6"></div>
        </div>
        
        <div className="contact-wave"></div>
      </section>

      {/* Contact Info Section */}
      <section className="contact-info-section">
        <div className="container">
          <div className="contact-row">
            {/* Contact Form */}
            <div className="contact-form-wrapper" data-aos="fade-up">
              <div className="contact-form-header">
                <h2>Send Us a Message</h2>
                <p>Fill out the form below and we'll get back to you as soon as possible.</p>
              </div>
              <form className="contact-form">
                <div className="form-group">
                  <input type="text" placeholder="Your Name" required />
                </div>
                <div className="form-group">
                  <input type="email" placeholder="Your Email" required />
                </div>
                <div className="form-group">
                  <input type="text" placeholder="Subject" required />
                </div>
                <div className="form-group">
                  <textarea placeholder="Your Message" rows="6" required></textarea>
                </div>
                <button type="submit" className="btn-submit">
                  Send Message <FaPaperPlane className="btn-icon" />
                </button>
              </form>
              
              {/* Animated corner SVGs */}
              <svg className="form-corner corner-tl" width="60" height="60" viewBox="0 0 60 60">
                <path d="M0,0 L60,0 C60,33.1371 33.1371,60 0,60 L0,0 Z" fill="#2c3c54" fillOpacity="0.05" />
                <animateTransform 
                  attributeName="transform" 
                  type="rotate" 
                  from="0 0 0" 
                  to="10 0 0" 
                  dur="4s" 
                  repeatCount="indefinite" 
                  additive="sum" />
              </svg>
              
              <svg className="form-corner corner-br" width="60" height="60" viewBox="0 0 60 60">
                <path d="M60,60 L0,60 C0,26.8629 26.8629,0 60,0 L60,60 Z" fill="#942c24" fillOpacity="0.05" />
                <animateTransform 
                  attributeName="transform" 
                  type="rotate" 
                  from="0 60 60" 
                  to="-10 60 60" 
                  dur="4s" 
                  repeatCount="indefinite" 
                  additive="sum" />
              </svg>
            </div>

            {/* Contact Info */}
            <div className="contact-info" data-aos="fade-up" data-aos-delay="200">
              <div className="contact-info-header">
                <h2>Contact Information</h2>
                <p>Feel free to contact us through any of these channels:</p>
              </div>
              
              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-icon">
                    <FaPhone />
                  </div>
                  <div className="contact-text">
                    <h3>Phone</h3>
                    <p>+264 81 571 3080</p>
                    <p>+264 81 589 3187</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">
                    <FaEnvelope />
                  </div>
                  <div className="contact-text">
                    <h3>Email</h3>
                    <p>info@namstack.com</p>
                    <p>support@namstack.com</p>
                  </div>
                </div>
                
                <div className="contact-item">
                  <div className="contact-icon">
                    <FaMapMarkerAlt />
                  </div>
                  <div className="contact-text">
                    <h3>Address</h3>
                    <p>Pioneerspark</p>
                    <p>Robert Mugabe Street, Windhoek</p>
                  </div>
                </div>
              </div>
              
              <div className="contact-social">
                <h3>Follow Us</h3>
                <div className="social-links">
                  <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
                    <FaFacebookF />
                  </a>
                  <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
                    <FaTwitter />
                  </a>
                  <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
                    <FaLinkedinIn />
                  </a>
                  <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
                    <FaInstagram />
                  </a>
                </div>
              </div>
              
              {/* Animated circles */}
              <div className="animated-circles">
                <div className="circle circle-1"></div>
                <div className="circle circle-2"></div>
                <div className="circle circle-3"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3683.7229000612087!2d17.08013601415516!3d-22.589464932302022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1c0b1b2136c5902f%3A0x374b6b5d20afdbd4!2s6%20Andimba%20Toivo-ya-Toivo%20Street%2C%20Windhoek!5e0!3m2!1sen!2sna!4v1624442749382!5m2!1sen!2sna"
          width="100%"
          height="450"
          title="Google map"
          allowFullScreen=""
          loading="lazy"
        ></iframe>
        
        {/* Map overlay SVG animation */}
        <div className="map-overlay">
          <svg className="map-svg" viewBox="0 0 1440 120" xmlns="http://www.w3.org/2000/svg">
            <path fill="#f8faff" d="M0,64L60,69.3C120,75,240,85,360,90.7C480,96,600,96,720,85.3C840,75,960,53,1080,48C1200,43,1320,53,1380,58.7L1440,64L1440,0L1380,0C1320,0,1200,0,1080,0C960,0,840,0,720,0C600,0,480,0,360,0C240,0,120,0,60,0L0,0Z"></path>
          </svg>
        </div>
      </section>
    </div>
  );
}
